<!-- @format -->

<ng-container *transloco="let t">
  @if (term(); as term) {
    <fudis-heading [level]="headingLevel()" [variant]="'lg'" class="text-capitalize"
      >{{ term.startYear }} – {{ term.name | localizedString }}</fudis-heading
    >
    <fudis-body-text [variant]="'lg-light'" class="fudis-mb-sm">
      {{ t("TIMELINE.STUDY_TERM.SUBHEADING", { valid: term.valid | localDateRange }) }}
    </fudis-body-text>
    @if (term.studyRightExpiredInfo) {
      <fudis-notification class="fudis-mb-sm">
        <fudis-body-text>
          {{
            t("TIMELINE.STUDY_RIGHT_EXPIRED_NOTIFICATION", {
              studyRightName: term.studyRightExpiredInfo.studyRightId | studyRightName | async | localizedString,
              studyRightExpiredDate: term.studyRightExpiredInfo.studyRightExpiredDateInclusive | localDateFormat,
            })
          }}
        </fudis-body-text>
      </fudis-notification>
    }
    <fudis-dl [variant]="'compact'" class="fudis-mb-md">
      <fudis-dl-item>
        <fudis-dt [contentText]="t('TIMELINE.TIMED_CREDITS')" />
        <fudis-dd [contentText]="term.timedCredits | creditRange: 'TEXT' : true" />
      </fudis-dl-item>
      <fudis-dl-item>
        <fudis-dt [contentText]="t('TIMELINE.ATTAINED_CREDITS')" />
        <fudis-dd [contentText]="term.attainedCredits | decimalNumber" />
      </fudis-dl-item>
    </fudis-dl>

    <fudis-grid [columns]="{ md: 2 }" [width]="'initial'" [columnGap]="'lg'" [rowGap]="'xl'">
      @for (period of term.periods; track period.locator) {
        <fudis-grid-item>
          <app-timeline-study-period [period]="period" [headingLevel]="childHeadingLevel()" />
        </fudis-grid-item>
      }
    </fudis-grid>
  }
</ng-container>
